import { FC } from "react";
import { WorkflowStep } from "@/types/workflow";
import { DocumentGeneratorProvider } from "@/components/documents/DocumentGeneratorProvider";
import { DocumentGenerator } from "@/components/documents/DocumentGenerator";
import { AIHelpDialog } from "./dialogs/AIHelpDialog";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { CheckCircle2 } from "lucide-react";

interface WorkflowDialogsProps {
  step?: WorkflowStep | null;
  showAIHelp?: boolean;
  showDocumentGenerator?: boolean;
  onAIHelpClose?: () => void;
  onDocumentGeneratorClose?: () => void;
  documents?: any[];
}

export const WorkflowDialogs: FC<WorkflowDialogsProps> = ({ 
  step,
  showAIHelp,
  showDocumentGenerator,
  onAIHelpClose,
  onDocumentGeneratorClose,
  documents 
}) => {
  const handleSuccess = () => {
    // Show success alert before closing
    const alert = document.createElement('div');
    alert.innerHTML = `
      <div class="fixed top-4 right-4 z-50 bg-green-50 border border-green-200 rounded-lg p-4 shadow-lg max-w-md">
        <div class="flex items-center gap-3">
          <CheckCircle2 class="h-5 w-5 text-green-500" />
          <div>
            <h3 class="font-semibold text-green-900">Dokument opprettet</h3>
            <p class="text-green-700 text-sm">Dokumentet er nå tilgjengelig i saken</p>
          </div>
        </div>
      </div>
    `;
    document.body.appendChild(alert);
    setTimeout(() => {
      document.body.removeChild(alert);
    }, 3000);
    
    onDocumentGeneratorClose?.();
  };

  return (
    <>
      <AIHelpDialog 
        step={step} 
        open={showAIHelp || false} 
        onClose={() => onAIHelpClose?.()}
      />
      
      <Dialog open={showDocumentGenerator} onOpenChange={() => onDocumentGeneratorClose?.()}>
        <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
          {showDocumentGenerator && step && (
            <DocumentGeneratorProvider>
              <DocumentGenerator 
                step={step}
                existingDocuments={documents}
                onClose={onDocumentGeneratorClose}
                onSuccess={handleSuccess}
                isWorkflowGeneration={true}
              />
            </DocumentGeneratorProvider>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}